
  var _styles = {
  "team-info-container": {
    "display": "flex",
    "width": "9.36rem",
    "marginTop": 0,
    "marginRight": "0.32rem",
    "marginBottom": 0,
    "marginLeft": "0.32rem"
  },
  "team-info-bg": {
    "position": "relative",
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "paddingTop": 0,
    "paddingRight": "0.32rem",
    "paddingBottom": 0,
    "paddingLeft": "0.32rem",
    "borderRadius": "0.48rem"
  },
  "team-info-header": {
    "position": "absolute",
    "top": 0,
    "left": "3.18667rem",
    "width": "2.98667rem",
    "marginTop": "0.34667rem"
  },
  "team-info-title": {
    "color": "rgb(17,17,17)",
    "fontSize": "0.42667rem",
    "fontWeight": "500",
    "textAlign": "center"
  },
  "team-info-call-section": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "marginTop": "1.25333rem"
  },
  "team-info-call-value-container": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "baseline",
    "justifyContent": "center",
    "position": "relative",
    "marginLeft": "0.13333rem"
  },
  "team-info-call-icon": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "marginRight": "0.12rem",
    "position": "absolute",
    "bottom": "0.26667rem",
    "left": "-1.41333rem"
  },
  "team-info-call-label": {
    "fontWeight": "400",
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "marginTop": 0,
    "marginRight": "0.12rem",
    "marginBottom": 0,
    "marginLeft": "0.08rem"
  },
  "team-info-call-value": {
    "color": "rgb(17,17,17)",
    "fontSize": "1.18667rem",
    "lineHeight": "1.46667rem",
    "fontWeight": "700"
  },
  "team-info-rank-ratio": {
    "width": "80%",
    "fontWeight": "400",
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "textAlign": "center",
    "marginTop": "-0.13333rem",
    "lineHeight": "0.42667rem"
  },
  "team-info-rank-wrap": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "team-info-rank": {
    "fontWeight": "400",
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "textAlign": "center",
    "lineHeight": "0.42667rem"
  },
  "team-info-rank__def": {
    "fontWeight": "400",
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "textAlign": "center",
    "lineHeight": "0.42667rem",
    "marginBottom": "0.36rem"
  },
  "team-info-member-section": {
    "display": "flex",
    "flexDirection": "column",
    "marginTop": "0.13333rem",
    "paddingTop": "0.36rem",
    "paddingRight": "0.4rem",
    "paddingBottom": 0,
    "paddingLeft": "0.4rem",
    "borderRadius": "0.32rem"
  },
  "team-info-menber-wish": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "marginBottom": "0.37333rem"
  },
  "team-info-member-wish-text": {
    "fontWeight": "400",
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.37333rem"
  },
  "team-info-member-wish-button": {
    "width": "1.30667rem",
    "height": "0.53333rem",
    "borderRadius": "0.26667rem",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "marginLeft": "0.26667rem"
  },
  "team-info-member-wish-button-text": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.29333rem"
  },
  "team-info-member-header": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "space-between",
    "alignItems": "center",
    "paddingRight": "0.32rem"
  },
  "team-info-member-title": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.37333rem"
  },
  "team-info-empty-slots-desc": {
    "fontWeight": "400",
    "color": "rgb(136,136,136)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem"
  },
  "team-info-empty-slot": {
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "width": "1.06667rem",
    "height": "1.06667rem",
    "backgroundColor": "rgb(225,204,255)",
    "borderRadius": "1.06667rem",
    "marginRight": "0.42667rem"
  },
  "team-info-plus-icon": {
    "position": "relative",
    "width": "0.37333rem",
    "height": "0.37333rem"
  },
  "team-info-plus-horizontal": {
    "position": "absolute",
    "width": "0.09333rem",
    "height": "0.37333rem",
    "left": "0.15rem",
    "backgroundColor": "rgb(184,134,255)",
    "borderRadius": "0.86667rem"
  },
  "team-info-plus-vertical": {
    "position": "absolute",
    "top": "0.13333rem",
    "width": "0.37333rem",
    "height": "0.09333rem",
    "backgroundColor": "rgb(184,134,255)",
    "borderRadius": "0.86667rem"
  },
  "team-info-buttons": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "space-between",
    "marginTop": "0.42667rem",
    "width": "9.36rem",
    "paddingTop": 0,
    "paddingRight": "0.4rem",
    "paddingBottom": 0,
    "paddingLeft": "0.4rem",
    "overflow": "visible"
  },
  "team-info-ranking-btn": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "backgroundColor": "rgba(0,0,0,0)",
    "borderWidth": "none",
    "borderColor": null,
    "paddingTop": 0,
    "paddingRight": 0,
    "paddingBottom": 0,
    "paddingLeft": 0
  },
  "team-info-circular-btn": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "position": "relative"
  },
  "team-info-btn-text": {
    "position": "absolute",
    "bottom": "-0.10667rem",
    "color": "rgb(17,17,17)",
    "fontSize": "0.37333rem",
    "fontWeight": "500",
    "lineHeight": "0.37333rem",
    "textAlign": "center",
    "backgroundColor": "rgb(255,243,13)",
    "paddingTop": "0.05333rem",
    "paddingRight": "0.16rem",
    "paddingBottom": "0.05333rem",
    "paddingLeft": "0.16rem",
    "borderRadius": "0.26667rem"
  },
  "team-info-invite-btn": {
    "backgroundColor": "rgba(0,0,0,0)",
    "borderWidth": "none",
    "borderColor": null,
    "paddingTop": 0,
    "paddingRight": 0,
    "paddingBottom": 0,
    "paddingLeft": 0,
    "marginTop": 0,
    "marginRight": "0.21333rem",
    "marginBottom": 0,
    "marginLeft": "0.21333rem"
  },
  "team-info-points-label": {
    "position": "absolute",
    "right": 0,
    "paddingTop": 0,
    "paddingRight": "13rpx",
    "paddingBottom": 0,
    "paddingLeft": "13rpx",
    "top": "-0.26667rem",
    "height": "0.50667rem",
    "backgroundColor": "rgb(255,45,25)",
    "borderRadius": "0.66667rem 0.66667rem 0.66667rem 0.2rem",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "overflow": "visible",
    "zIndex": 1
  },
  "team-info-points-label-text": {
    "color": "rgb(255,255,255)",
    "fontSize": "0.26667rem"
  }
};



  module.exports = _styles;
  